import { render, staticRenderFns } from "./ListDocuments.vue?vue&type=template&id=51f22ef3&scoped=true&"
import script from "./ListDocuments.vue?vue&type=script&lang=js&"
export * from "./ListDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f22ef3",
  null
  
)

export default component.exports